import React from 'react';

interface CitationProps {
  name: string,
  photo: string,
  role: string,
  text: string,
}

export const Citation: React.FC<CitationProps> = ({
  name, photo, role, text,
}: CitationProps) => (
  <div className="citation">
    <img className="citation__photo" src={photo} alt="fotografia cytowanych" />
    <div className="citation__content">
      <div className="citation__text">
        <p className="citation__parenthesis">“</p>
        {text}
      </div>
      <p className="citation__signature">
        {name.toUpperCase()}
        ,
        {' '}
        <span className="citation__role">{role.toUpperCase()}</span>
      </p>
    </div>
  </div>
);
